import React, { ReactNode } from 'react';
import styled from 'styled-components';

const StyledDashboardContainer = styled.div<{
  hasSyncMessage: boolean;
  hasAdminTasks: boolean;
}>`
  width: 100%;
  display: grid;
  gap: var(--default-padding);
  grid-template-columns: repeat(6, minmax(auto, 1fr));
  grid-template-areas: ${({ hasSyncMessage, hasAdminTasks }) =>
    '"cb cb cb cb cb cb"\n' +
    `${hasSyncMessage ? '"m m m m m m"\n' : ''}` +
    `${hasAdminTasks ? '"at at at at at at"\n' : ''}` +
    // TODO: uncomment when filters are added
    // '"df df df df df df"\n' +
    // TODO: uncomment when overview is added
    // '"o1 o1 o2 o2 o3 o3"\n' +
    '"ac ac ac ac ac ac"\n'};

  #sync-error-message {
    grid-area: m;
  }

  .admin-tasks {
    grid-area: at;
  }

  #admin-dashboard {
    grid-area: ac;
  }

  @media (max-width: 1439px) {
    grid-template-columns: repeat(4, minmax(auto, 1fr));
    grid-template-areas: ${({ hasSyncMessage, hasAdminTasks }) =>
      '"cb cb cb cb"\n' +
      `${hasSyncMessage ? '"m m m m"\n' : ''}` +
      `${hasAdminTasks ? '"at at at at"\n' : ''}` +
      // TODO: uncomment when filters are added
      // '"df df df df"\n' +
      // TODO: uncomment when overview is added
      // '"o1 o1 o2 o2"\n' +
      // '"o3 o3 o3 o3"\n' +
      '"ac ac ac ac"\n'};
  }

  @media (max-width: 799px) {
    grid-template-columns: repeat(2, minmax(auto, 1fr));
    grid-template-areas: ${({ hasSyncMessage, hasAdminTasks }) =>
      '"cb cb"\n' +
      `${hasSyncMessage ? '"m m"\n' : ''}` +
      `${hasAdminTasks ? '"at at"\n' : ''}` +
      // TODO: uncomment when filters are added
      // '"df df"\n' +
      // TODO: uncomment when overview is added
      // '"o1 o1"\n' +
      // '"o2 o2"\n' +
      // '"o3 o3"\n' +
      '"ac ac"\n'};
  }
`;

export const AdminDashboardLayoutV2: React.FC<{
  children: ReactNode;
  hasSyncMessage?: boolean;
  isAdminTaskFeatureEnabled?: boolean;
}> = ({ children, hasSyncMessage, isAdminTaskFeatureEnabled }) => {
  return (
    <StyledDashboardContainer
      hasSyncMessage={!!hasSyncMessage}
      hasAdminTasks={!!isAdminTaskFeatureEnabled}
    >
      {children}
    </StyledDashboardContainer>
  );
};
